import User from '@alltrails/shared/types/User';
import useSelector from 'hooks/useSelector';

export default function useUser(): User {
  return useSelector(state => state.user);
}
